import Swiper from 'swiper/bundle';

jQuery(document).ready(function () {
   scrollTop();
   swiperSlider();
   mobileMenu();
   enhanceNumberInputs();
   ansprechpartnerAjaxFilter();
   fahrerAjaxFilter();
   initCustomParallax();
   currentWeekEventsSwiper();
   translateWeatherToGerman();
   modal();
});


function swiperSlider() {
   let mySwiper = new Swiper('.hero-slider', {
      loop: true,
      grabCursor: true,
      allowTouchMove: true,
      simulateTouch: true,
      pagination: {
         el: '.swiper-pagination',
         clickable: true,
      },
      autoplay: {
         delay: 6000,
         disableOnInteraction: false,
      },
      speed: 600,
      effect: 'fade',
      fadeEffect: {
         crossFade: true
      }
   });

}

function scrollTop() {
   $(window).scroll(function () {
      if ($(this).scrollTop() > 800) {
         $('.scroll-to-top').addClass('active');
      } else {
         $('.scroll-to-top').removeClass('active');
      }
   });

   $('.scroll-to-top').click(function () {
      $('html, body').animate({scrollTop: 0}, 100);
      return false;
   });
}


function mobileMenu() {
   const burger = $('.burger-menu');
   const closeIcon = $('.close-menu-icon');
   const overlay = $('.mobile-overlay');
   const menuWrapper = $('.mobile-menu-wrapper');
   const headerLeft = $('.header-mobile .flex-left');
   const headerRight = $('.header-mobile .flex-right');
   const body = $('body');

   const openMenu = () => {
      overlay.addClass('active');
      menuWrapper.addClass('active');
      headerLeft.addClass('hidden');
      headerRight.addClass('menu-open');
      body.addClass('no-scroll');
   };

   const closeMenu = () => {
      overlay.removeClass('active');
      menuWrapper.removeClass('active');
      headerLeft.removeClass('hidden');
      headerRight.removeClass('menu-open');
      body.removeClass('no-scroll');
   };

   burger.on('click', openMenu);
   closeIcon.on('click', closeMenu);
   overlay.on('click', closeMenu);
}


function enhanceNumberInputs() {
   $('.flex-items input[type="number"]').each(function () {
      const $input = $(this);
      const $wrapper = $('<span class="number-wrapper"></span>');
      const $minus = $('<button type="button">-</button>');
      const $plus = $('<button type="button">+</button>');

      // Wrap and append elements
      $input.before($wrapper);
      $wrapper.append($minus, $input, $plus);

      // Add click functionality
      $minus.on('click', function () {
         $input[0].stepDown();
      });
      $plus.on('click', function () {
         $input[0].stepUp();
      });
   });
}

function ansprechpartnerAjaxFilter() {
   var buttons = $('.ansprechpartner-filter-btn');
   var desktopList = $('#ansprechpartner-list-desktop');
   var mobileList = $('#ansprechpartner-list-mobile');
   var mobileSwiper;

   // Hide lists until first load finishes
   desktopList.hide();
   mobileList.hide();

   function initMobileSwiper() {
      // Only initialize on screens smaller than 768px
      if ($(window).width() < 768 && mobileList.find('.swiper-wrapper .swiper-slide').length) {
         // Destroy existing swiper if any
         if (mobileSwiper) {
            mobileSwiper.destroy(true, true);
         }
         mobileSwiper = new Swiper('#ansprechpartner-list-mobile', {
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
               el: '.swiper-pagination',
               clickable: true
            },
            navigation: false
         });
      }
   }

   function loadAnsprechpartner(term) {
      // Add loading state
      desktopList.addClass('loading');
      mobileList.addClass('loading');

      $.ajax({
         url: ajax.url,
         type: 'POST',
         data: {
            action: 'filter_ansprechpartner',
            term: term
         },
         success: function (response) {
            if (response.success) {
               // Inject the same HTML into both desktop and mobile
               desktopList.html(response.data);
               mobileList.html(response.data);

               // For mobile, wrap items in swiper structure if not already
               if (mobileList.find('.swiper-wrapper').length === 0) {
                  mobileList.children('.ansprechpartner-item').addClass('swiper-slide');
                  mobileList.children('.swiper-slide').wrapAll('<div class="swiper-wrapper"></div>');
                  if (mobileList.find('.swiper-pagination').length === 0) {
                     mobileList.append('<div class="swiper-pagination"></div>');
                  }
               }

               // Show the proper container based on screen size
               if ($(window).width() < 768) {
                  mobileList.show();
                  desktopList.hide();
                  initMobileSwiper();
               } else {
                  desktopList.show();
                  mobileList.hide();
               }

            } else {
               desktopList.html('<p>Keine Ansprechpartner gefunden.</p>').show();
               mobileList.html('<p>Keine Ansprechpartner gefunden.</p>').show();
            }
         },
         complete: function () {
            desktopList.removeClass('loading');
            mobileList.removeClass('loading');
         }
      });
   }

   // Handle category button click
   buttons.on('click', function () {
      var btn = $(this);
      var term = btn.data('filter');

      buttons.removeClass('active');
      btn.addClass('active');

      loadAnsprechpartner(term);
   });

   // Automatically load first category
   var $firstBtn = buttons.first();
   if ($firstBtn.length) {
      buttons.removeClass('active');
      $firstBtn.addClass('active');
      loadAnsprechpartner($firstBtn.data('filter'));
   }
}

function fahrerAjaxFilter() {
   var buttons = $('.fahrer-filter-btn');
   var desktopList = $('#fahrer-list-desktop');
   var mobileList = $('#fahrer-list-mobile');
   var mobileSwiper;

   // Hide lists until first load finishes
   desktopList.hide();
   mobileList.hide();

   function initMobileSwiper() {
      // Only initialize on screens smaller than 768px
      if ($(window).width() < 768 && mobileList.find('.swiper-wrapper .swiper-slide').length) {
         // Destroy existing swiper if any
         if (mobileSwiper) {
            mobileSwiper.destroy(true, true);
         }
         mobileSwiper = new Swiper('#fahrer-list-mobile', {
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
               el: '.swiper-pagination',
               clickable: true
            },
            navigation: false
         });
      }
   }

   function loadFahrer(term) {
      // Add loading state
      desktopList.addClass('loading');
      mobileList.addClass('loading');

      $.ajax({
         url: ajax.url,
         type: 'POST',
         data: {
            action: 'filter_fahrer',
            term: term
         },
         success: function (response) {
            if (response.success) {
               // Inject the same HTML into both desktop and mobile
               desktopList.html(response.data);
               mobileList.html(response.data);

               // For mobile, wrap items in swiper structure if not already
               if (mobileList.find('.swiper-wrapper').length === 0) {
                  mobileList.children('.fahrer-item').addClass('swiper-slide');
                  mobileList.children('.swiper-slide').wrapAll('<div class="swiper-wrapper"></div>');
                  if (mobileList.find('.swiper-pagination').length === 0) {
                     mobileList.append('<div class="swiper-pagination"></div>');
                  }
               }

               // Show the proper container based on screen size
               if ($(window).width() < 768) {
                  mobileList.show();
                  desktopList.hide();
                  initMobileSwiper();
               } else {
                  desktopList.show();
                  mobileList.hide();
               }

            } else {
               desktopList.html('<p>Keine Ansprechpartner gefunden.</p>').show();
               mobileList.html('<p>Keine Ansprechpartner gefunden.</p>').show();
            }
         },
         complete: function () {
            desktopList.removeClass('loading');
            mobileList.removeClass('loading');
         }
      });
   }

   // Handle category button click
   buttons.on('click', function () {
      var btn = $(this);
      var term = btn.data('filter');

      buttons.removeClass('active');
      btn.addClass('active');

      loadFahrer(term);
   });

   // Automatically load first category
   var $firstBtn = buttons.first();
   if ($firstBtn.length) {
      buttons.removeClass('active');
      $firstBtn.addClass('active');
      loadFahrer($firstBtn.data('filter'));
   }
}



function currentWeekEventsSwiper() {
   var eventsSwiper = new Swiper('.events-slider-container', {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      speed: 800,
      autoplay: {
         delay: 3000,
         disableOnInteraction: false,
         pauseOnMouseEnter: false,
      },
      pagination: {
         el: '.swiper-pagination',
         clickable: true,
      },
      breakpoints: {
         480: {slidesPerView: 1},
         768: {slidesPerView: 2},
         1024: {slidesPerView: 4},
      },
   });

   eventsSwiper.autoplay.start();
}

function initCustomParallax() {
   var $parallaxElements = $('.custom-parallax');
   if ($parallaxElements.length === 0 || $(window).width() < 1024) {
      $(window).off('scroll.customParallax');
      $parallaxElements.css('transform', 'none');
      return;
   }

   var scrollY = window.pageYOffset;
   var currentY = window.pageYOffset;
   var friction = 0.1; // Lower is smoother/slower (0.05 to 0.1 is best)

   // Update scroll position on scroll event
   $(window).on('scroll.customParallax', function() {
      scrollY = window.pageYOffset;
   });

   function update() {
      // The "Lerp" math: Current position + (Distance to target * friction)
      currentY += (scrollY - currentY) * friction;

      $parallaxElements.each(function() {
         var $el = $(this);
         var speed = $el.data('speed') || 2;
         var yPos = -(currentY * speed / 10);

         $el[0].style.transform = 'translate3d(0, ' + yPos.toFixed(2) + 'px, 0)';
      });

      // Keep the loop running
      window.parallaxAnimationFrame = requestAnimationFrame(update);
   }

   // Start the loop
   cancelAnimationFrame(window.parallaxAnimationFrame);
   update();
}

$(window).on('resize', function() {
   clearTimeout(window.parallaxResizer);
   window.parallaxResizer = setTimeout(initCustomParallax, 200);
});


const updateText = () => {
   const el = document.querySelector(
      ".wc-block-components-express-payment-continue-rule--checkout"
   );

   if (el && el.textContent !== "Oder unten fortfahren") {
      el.textContent = "Oder unten fortfahren";
   }
};

document.addEventListener("DOMContentLoaded", () => {
   updateText();

   const observer = new MutationObserver(updateText);
   observer.observe(document.body, {
      childList: true,
      subtree: true,
   });
});




function translateWeatherToGerman() {
   var $container = $('.splw-lite-daily-weather-details');

   $container.each(function () {
      var $this = $(this);

      // Tooltips (titles)
      $this.find('.splw-icon-humidity .details-icon').attr('title', 'Luftfeuchtigkeit');
      $this.find('.splw-icon-pressure .details-icon').attr('title', 'Luftdruck');
      $this.find('.splw-icon-wind .details-icon').attr('title', 'Wind');

      // Labels
      $this.find('.splw-gusts-wind .options-title').text('Windböen:');
      $this.find('.splw-clouds .options-title').text('Bewölkung:');
      $this.find('.splw-visibility .options-title').text('Sichtweite:');
      $this.find('.splw-sunrise .options-title').text('Sonnenaufgang:');
      $this.find('.splw-sunset .options-title').text('Sonnenuntergang:');
   });
}

function modal() {
   // teaser
   setTimeout(function () {
      if (Cookies.get('teaser') == null) {
         Cookies.set('teaser', '1', { expires: 1 });
         jQuery('.teaser').addClass('animateshow');
      }
   }, 5000);

   jQuery('.teaser .close').click(function () {
      jQuery('.teaser').removeClass('animateshow');
      setTimeout(function () {
         jQuery('.teaser').css('display', 'none');
      }, 500);
   });
}